import React, { useState, useEffect } from 'react'
import Container from 'olive-react-myoneui/lib/Container';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import iconVisa from "../assets/images/icons/icon-visa.png";
import iconMastercard from "../assets/images/icons/icon-mastercard.png";
import iconRupay from "../assets/images/icons/icon-rupay.png";
import { Button } from 'olive-react-myoneui';
import ListGroup from 'olive-react-myoneui/lib/ListGroup'
import { useSelector } from 'react-redux';
import EnquiryForm from './EnquiryForm';
import CookieConsent from './CookieConsent';
import CourseReminderModal from "./student-dashboard/CourseReminderModal";
import { useSearchParams } from 'react-router-dom';
import { checkCircleFill } from '../constants/icons';
import ToastContainer from 'olive-react-myoneui/lib/ToastContainer';
import Toast from 'olive-react-myoneui/lib/Toast';
import ToastInfo from 'olive-react-myoneui/lib/ToastInfo';
import ThankYouModal from './student-dashboard/ThankYouModal';
import { getCache } from './Page/utils/cacheManager';
import { getAllEnquiryFields } from '../api/initialApis';
import { Helmet } from 'react-helmet';
import { fetchAnalytics } from '../api/analytics';
import { getAnalyticsCode, parseScriptTags } from '../helpers/seo_helper';
import FooterScriptsPortal from './FooterScriptsPortal';
// import Button from 'olive-react-myoneui/lib/Button';

function Footer({ className}) {
  const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const informationBars = useSelector((state) => state.user.headerMenus.information_bars);
  const paths       = useSelector((state) => state.user.paths);
  let popUpMessage = "test";
  let popUpImage = null;
  let backgroundColor = "#ffffff";
  let textColor = "#000000";
  const [currentPopupIndex, setCurrentPopupIndex] = useState(0); // New state for the current popup message index
  const [fields, setFields]                       = useState({});
  const [analytics,setAnalytics]                  = useState('');
  const miscellaneous = useSelector((state) => state.user.miscellaneous);

  const popUpMessages = informationBars
  .filter((elem) => elem?.n_notification_bar_type === '1')
  .map((elem, index) => ({
    message: elem?.n_content || '',
    image: elem?.n_image ? paths.flash_notification_path + elem.n_image : '',
    backgroundColor: elem.n_background_color || '#ffffff',
    textColor: elem.n_text_color || '#000000',
    link: elem.n_link,
    index,
  }));

  const [notificationBarShow, setNotificationBarShow] = useState(
    popUpMessages.length > 0 &&
    (localStorage.notificationPopUp
      ? new Date().getTime() > parseInt(localStorage.notificationPopUp) + 86400000
      : true)
  );
 
  const notificationBarClose = () => {
    if (currentPopupIndex < popUpMessages.length - 1) {
      setCurrentPopupIndex(currentPopupIndex + 1);
    } else {
      localStorage.setItem('notificationPopUp', new Date().getTime());
      setCurrentPopupIndex(0);
      setNotificationBarShow(false);
    }
  };

  const [modalShow, setModalShow] = React.useState(false);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const handleShowModal = () => {
    setModalShow(true);
  };

  const handleHideModal = () => {
    setModalShow(false);
    notificationBarClose();
  };
  useEffect(() => {
    const init = async () => {
      const content = await getCache("all_enquiry_fields", getAllEnquiryFields, {}, 2592000);
      setFields(content.fields);
    }
    init();
  }, []);
  const [validated, setValidated] = useState(false);
  const [showResults, setShowResults] = React.useState(false);
  const showEnquiryForm = () => setShowResults(true);
  const footerMenus = useSelector((state) => state.user.footer_pages);
  const website     = useSelector((state) => state.user.website);
  let footer_settings       = (typeof website.footer !== 'undefined') ? website.footer : {};
  let enquiry_form_button   = ((typeof footer_settings.contact_form_type === 'undefined') || ((typeof footer_settings.contact_form_type !== 'undefined') && footer_settings.contact_form_type == 1));
  let year                  = new Date().getFullYear();
  const siteName            = website.site_name;
  const siteLogo            = paths.logo_path+website.site_logo;
  const paymentLogo         = (typeof website.payment_logo !== 'undefined')? false : true;

  const loadEnquiryNow = () => 
  {
    if(enquirySubmitted === false){
      window.location.href = "/enquiry";
    } else {
      setEnquirySubmitted(false);
    }
  }
  
  const [enquirySuccessMessage, setEnquirySuccessMessage] = useState("Thank you for you message, You’ll be hearing from us soon");
  const [enquirySuccessTitle, setEnquirySuccessTitle] = useState("Enquiry Submitted Successfully");
  const [showSuccessSnack, setShowSuccessSnack] = useState(false);
  const toggleShowA = () => setShowSuccessSnack(!showSuccessSnack);

  const capitalizeFirstLowercaseRest = str => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const enquiryDropItems = [{ "name": "Laptop" }, {"name": "Phone" }, { "name": "Tablet" }];

  const [modalThankYouShow, setModalThankYouShow] = React.useState(true);
  const [enquirySubmitted, setEnquirySubmitted]   = React.useState(false);
  const fromEnquiryPage = false;

  useEffect(() => {
      const analyticsData = async () => {
        const analytics = await fetchAnalytics(miscellaneous.account_id);
        setAnalytics(analytics);
      };
      analyticsData();
    }, []);

  
  return (
    <>
    <div className={`${className || ''} footer-wrapper pt-5 pb-3 px-2 px-md-4` + (searchParams.get('privacy') === "" ? " d-none" : "")}>
      <Container>
        <Row>
          <Col lg={12} className="mb-4">
            <a href="#" className="footer-logo">
              <img src={siteLogo} className="img-fluid" alt="Logo" />
            </a>
          </Col>
        </Row>
        <Row>
          <Col lg={8} className="footer-left-content-wrapper">
            <Row>
              {
                (typeof footer_settings.business_address_visibility !== 'undefined') && (footer_settings.business_address_visibility == "1")? (
                  <Col lg={4}>
                  <div className="footer-links-col">
                    <h1 className="footer-heading">Contact us</h1>
                    <ListGroup as="ul">
                        <ListGroup.Item as="li" className="bg-transparent border-0 p-0">
                          <p className="desc mb-0" dangerouslySetInnerHTML={{__html: website.site_address}}></p>
                        </ListGroup.Item>
                        {
                          website.site_phone && website.contact_number_visible == '1' &&
                          <ListGroup.Item as="li" className="bg-transparent border-0 p-0">
                            <a className="link" href={`tel: ${website.site_phone}`}>{website.site_phone}</a>
                          </ListGroup.Item>
                        }
                        
                      {/* <li>
                        <p>Informatica Netherland <br/>B.V. Edisonbaan 14a 3439<br/>MN Nieuwegian, Netherlands</p>
                      </li>
                      <li>
                        <a href='tel:+91 7012669740'>+91 7012669740</a>
                      </li> */}
                    </ListGroup>
                  </div>
                  </Col>
                ) : ''
              }
              {
                (footerMenus.length > 0) && 
                <Col lg={6}>
                <div className="footer-links-col col-2-content">
                  <h1 className="footer-heading">Useful links</h1>
                    <ListGroup as="ul">
                    {
                      footerMenus.map((fMenu) => {
                        let showLinkC  = ((fMenu['mm_connected_as_external'] == '1' ) ? fMenu['mm_external_url']: fMenu['mm_item_connected_slug']);
                        let pageUrl   = fMenu['mm_item_connected_slug']
                        let attributes = ((fMenu['mm_new_window'] == '1') ? 'target="_blank"':'');
                        pageUrl   = ((typeof fMenu['mm_connected_as_external'] !== 'undefined') && fMenu['mm_connected_as_external'] == '1' ) ? fMenu['mm_external_url']: pageUrl;
                        
                                                   
                        if(showLinkC || fMenu['p_connected_menu'] != ''){
                          return(
                            (attributes != '') ? (
                              <ListGroup.Item as="li" className="bg-transparent border-0 p-0">
                                <a href={`${pageUrl}`} target="_blank" className="link">{`${capitalizeFirstLowercaseRest(fMenu['mm_name'])}`}</a>
                              </ListGroup.Item>
                            ) : (
                              <ListGroup.Item as="li" className="bg-transparent border-0 p-0">
                                <a href={`${pageUrl}`} className="link">{`${capitalizeFirstLowercaseRest(fMenu['mm_name'])}`}</a>
                              </ListGroup.Item>
                            )
                          )
                        }
                      })
                    }
                  </ListGroup>
                </div>
              </Col>
              }
              
            </Row>
          </Col>
          <Col lg={4} className="ps-lg-4">
            {
              (typeof(footer_settings.contact_form_visibility) !== 'undefined' && footer_settings.contact_form_visibility == "1" && (website.site_email).length > 0) ? (
                <div className="footer-links-col contact-us-center">
                  {footer_settings?.contact_form_type == '1' && (
                    <h1 className="footer-heading">{fields.enquiry_form_title}</h1>
                  )}
                  {
                    (enquiry_form_button === true || enquirySubmitted === true) ? (
                      <ListGroup as="ul">
                        <ListGroup.Item as="li" className="bg-transparent border-0 p-0">
                          <p className="desc">{fields.enquiry_description}</p>
                          {
                            enquirySubmitted === true &&
                              <div className="message-success-wrapper mb-3">
                                {checkCircleFill} <span className="message-success">Enquiry Submitted Successfully</span>
                              </div> 
                          }
   
                          <Button variant="secondary" className="mt-1" onClick={loadEnquiryNow}>
                            {
                            enquirySubmitted === true ? (
                              'Enquire Again') :
                              (fields.button_label || 'Enquire Now')}
                          </Button>
                        </ListGroup.Item>
                      </ListGroup>
                    ) : (
                      <EnquiryForm fromEnquiryPage={fromEnquiryPage} setEnquirySubmitted={setEnquirySubmitted} setShowSuccessSnack={setShowSuccessSnack} setEnquirySuccessTitle={setEnquirySuccessTitle} setEnquirySuccessMessage={setEnquirySuccessMessage}/>
                    )
                  }
                  
                </div>
              ) : ''
            }
          </Col>
        </Row>
        <div className="footer-separator mt-4 mb-2"></div>
        <Row className="copyright-flex-wrapper align-items-center">
          <Col lg={6}>
            <p className="copyright-content mb-2 mb-lg-0">Copyright &copy; {year} {siteName}. All rights reserved</p>
          </Col>
          <Col lg={6}>
            {
              paymentLogo && 
              <>
              <div className="footer-payment-options">
                <p className="payment-title">Secure payments with:</p>
                <ListGroup as="ul" className="flex-row">
                  <ListGroup.Item as="li" className="border-0 p-0">
                    <a className="link" href="#">
                      <img src={iconVisa} className="img-fluid img-card"/>
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" className="border-0 p-0">
                    <a className="link" href="#">
                      <img src={iconMastercard} className="img-fluid img-card"/>
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" className="border-0 p-0">
                    <a className="link" href="#">
                      <img src={iconRupay} className="img-fluid img-card"/>
                    </a>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </>
            }
            
          </Col>
        </Row>
      </Container>
      {/* Footer Scripts */}
      <FooterScriptsPortal analytics={analytics} />
      
    </div>
    <ToastContainer position="bottom-center" className="custom-snackbar-success p-3 position-fixed zindex-high">
      <Toast variant="primary" show={showSuccessSnack} onClose={toggleShowA}>
        <Toast.Body>
          <ToastInfo toastDescription={enquirySuccessTitle} />
          <div className="action-wrapper">
            <Button
              variant="primary"
              type="button"
              size="sm"
              className="btn-round bg-primary-fade"
              aria-label="Close"
              onClick={toggleShowA}
            >
              Close
            </Button>
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
    {notificationBarShow && popUpMessages.length > 0 && ( 
      <CourseReminderModal
        show={notificationBarShow}
        onHide={notificationBarClose}
        popUpMessage={popUpMessages[currentPopupIndex]?.message}
        popUpImage={popUpMessages[currentPopupIndex]?.image}
        backgroundColor={popUpMessages[currentPopupIndex]?.backgroundColor}
        textColor={popUpMessages[currentPopupIndex]?.textColor}
        link={popUpMessages[currentPopupIndex]?.link}
      />
    )}
    {/* Enquiry Form Modal */}
    {/* <ThankYouModal
      show={modalThankYouShow}
      onHide={() => setModalThankYouShow(false)}
    /> */}

    {/* Full Loader */}
   
    </>
  );
}

export default Footer;
